export const SHOP_TIRES_TITLE = 'Shop Tires'
export const APPOINTMENT_TITLE = 'Request Appointment'
export const SCHEDULE_APPOINTMENT_TITLE = 'Schedule Appointment'
export const SPECIALS_TITLE = 'View Specials'
export const SEE_OFFERS_TITLE = 'See Offers'
export const SERVICES_TITLE = 'View Services'
export const SHOP_TIRES_DESCRIPTION = 'Explore our vast inventory of tires'
export const APPOINTMENT_DESCRIPTION = 'Oil change, tire services, brakes, batteries & more!'

export const MAIN_YMME_SOURCE = 'MainYmme'

export const INITIAL_HOVER_DATA = {
  tire: false,
  appointment: false,
  specials: false,
  services: false
}
